import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { useTextScramble } from '../hooks/useTextScramble'

const socialLinks = [
	{
		href: 'https://www.linkedin.com/in/zakarya-butt-7a4937106/',
		icon: 'fab fa-linkedin',
		label: 'LinkedIn',
	},
	{
		href: 'https://twitter.com/zakarya_butt',
		icon: 'fab fa-twitter',
		label: 'Twitter',
	},
	{
		href: 'https://github.com/zakarya23',
		icon: 'fab fa-github',
		label: 'GitHub',
	},
]

const ContactMe = () => {
	const [ref, isVisible] = useScrollAnimation(0.1)
	const scrambled = useTextScramble('CONNECT', isVisible, 950)

	return (
		<section id='contact' className='py-24 px-6 lg:px-12' ref={ref}>
			<div className='max-w-6xl mx-auto'>
				<div
					className='transition-all duration-700'
					style={{
						opacity: isVisible ? 1 : 0,
						transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
					}}>
					<p className='text-blue-400 font-mono text-xs tracking-[0.25em] uppercase mb-3'>
						Get In Touch
					</p>
					<h2 className='text-4xl lg:text-6xl font-bold text-white mb-4'>
						Let's{' '}
						<span className='bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent font-mono'>
							{scrambled}
						</span>
					</h2>
					<div className='w-16 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full mb-12' />

					<div className='max-w-lg'>
						<p className='text-gray-400 text-base leading-relaxed mb-8'>
							If you ever want to grab a coffee (virtually) or just want a quick
							chat — you can find me on social media or reach out directly.
						</p>

						{/* Social icons */}
						<div className='flex gap-4 mb-8'>
							{socialLinks.map(({ href, icon, label }) => (
								<a
									key={label}
									href={href}
									target='_blank'
									rel='noopener noreferrer'
									aria-label={label}
									className='w-11 h-11 rounded-full flex items-center justify-center border border-white/10 text-gray-500 hover:text-blue-400 hover:border-blue-500/50 hover:bg-blue-500/8 transition-all duration-300 hover:scale-110'
									style={{ background: 'rgba(255,255,255,0.03)' }}>
									<i className={`${icon} text-lg`} />
								</a>
							))}
						</div>

						{/* Contact details */}
						<div className='flex flex-col gap-3'>
							<div
								className='flex items-center gap-4 p-4 rounded-xl border border-white/8'
								style={{ background: 'rgba(255,255,255,0.03)' }}>
								<div className='w-9 h-9 rounded-full bg-blue-500/15 flex items-center justify-center flex-shrink-0'>
									<i className='fas fa-phone-alt text-blue-400 text-xs' />
								</div>
								<span className='text-gray-300 text-sm'>+61406387075</span>
							</div>
							<a
								href='mailto:z4zakarya@gmail.com'
								className='flex items-center gap-4 p-4 rounded-xl border border-white/8 hover:border-blue-500/30 transition-colors duration-300'
								style={{ background: 'rgba(255,255,255,0.03)' }}>
								<div className='w-9 h-9 rounded-full bg-blue-500/15 flex items-center justify-center flex-shrink-0'>
									<i className='fas fa-envelope text-blue-400 text-xs' />
								</div>
								<span className='text-gray-300 text-sm'>
									z4zakarya@gmail.com
								</span>
							</a>
						</div>
					</div>
				</div>

				{/* Footer */}
				<div className='mt-24 pt-8 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-2 text-gray-600 text-xs'>
					<p>
						Designed & built by{' '}
						<span className='text-blue-400/80'>Zakarya Butt</span>
					</p>
					<p>© {new Date().getFullYear()}</p>
				</div>
			</div>
		</section>
	)
}

export default ContactMe
